import { HttpContextToken, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';

export type UploadProgressCallback = (loaded: number, total: number | undefined) => void;

export const UPLOAD_PROGRESS = new HttpContextToken<UploadProgressCallback | null>(() => null);

export const uploadProgressInterceptor: HttpInterceptorFn = (req, next) => {
    const onProgress = req.context.get(UPLOAD_PROGRESS);
    if (!onProgress) {
        return next(req);
    }

    return next(req.clone({ reportProgress: true })).pipe(
        tap(event => {
            if (event.type === HttpEventType.UploadProgress) {
                onProgress(event.loaded, event.total);
            }
        }),
    );
};
